/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAttachmentRequest
 */
export interface CreateAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentRequest
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentRequest
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAttachmentRequest
     */
    size?: string;
}

/**
 * Check if a given object implements the CreateAttachmentRequest interface.
 */
export function instanceOfCreateAttachmentRequest(value: object): value is CreateAttachmentRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CreateAttachmentRequestFromJSON(json: any): CreateAttachmentRequest {
    return CreateAttachmentRequestFromJSONTyped(json, false);
}

export function CreateAttachmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAttachmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'url': json['url'],
        'type': json['type'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}

export function CreateAttachmentRequestToJSON(json: any): CreateAttachmentRequest {
    return CreateAttachmentRequestToJSONTyped(json, false);
}

export function CreateAttachmentRequestToJSONTyped(value?: CreateAttachmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'url': value['url'],
        'type': value['type'],
        'size': value['size'],
    };
}

